import Vue from 'vue'

import {
  SpinnerPlugin,
  NavbarPlugin,
  NavPlugin,
  CollapsePlugin,
  DropdownPlugin,
  ListGroupPlugin,
  LayoutPlugin,
  PaginationNavPlugin,
  CardPlugin,
  ImagePlugin,
  CarouselPlugin,
  ButtonPlugin,
  InputGroupPlugin,
  FormSelectPlugin,
  FormInputPlugin,
  ToastPlugin
} from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

Vue.use(SpinnerPlugin)
Vue.use(NavbarPlugin)
Vue.use(NavPlugin)
Vue.use(CollapsePlugin)
Vue.use(DropdownPlugin)
Vue.use(ListGroupPlugin)
Vue.use(LayoutPlugin)
Vue.use(PaginationNavPlugin)
Vue.use(CardPlugin)
Vue.use(ImagePlugin)
Vue.use(CarouselPlugin)
Vue.use(ButtonPlugin)
Vue.use(InputGroupPlugin)
Vue.use(FormSelectPlugin)
Vue.use(FormInputPlugin)
Vue.use(ToastPlugin)
